<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>校招信息管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center" class="pa-4">
        <v-btn color="primary" @click="downloadTemplate()">
          下载汇入Excel模板
        </v-btn>
        <v-btn color="primary" @click="downloadErrorExcelLog()">
          下载上次错误Excel日志
        </v-btn>
        <v-btn color="primary" @click="importIntershipNewsExcel()">
          汇入校招信息Excel
        </v-btn>
        <v-file-input
          show-size
          v-model="selectedFile"
          label="选择档案上传"
          accept=".xlsx, .xls"
          @change="handleFileChange"
        ></v-file-input>
        <v-btn color="primary" @click="showCreateIntershipNewsDialog()"
          > + IntershipNews
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="intershipNewsList"
      :page="currentPage"
      :items-per-page="itemsPerPage"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions
      }"
      class="elevation-1"
      @update:page="handlePageChange"
      @update:items-per-page="handleItemsPerPageChange"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small @click="showEditIntershipNewsDialog(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
        <v-btn small @click="showDeleteIntershipNewsConfirm(item)"><v-icon small>mdi-delete</v-icon></v-btn>
      </template>
    </v-data-table>

    <create-intership-news-popup ref="createPopup" @saved="fetchIntershipNews" />

    <edit-intership-news-popup ref="editPopup" @saved="fetchIntershipNews" />

    <delete-intership-news-popup ref="deletePopup" :item="selectedItem" @saved="fetchIntershipNews"/>
  </v-container>
</template>

<script>
import CreateIntershipNewsPopup from '@/components/CreateIntershipNewsPopup'
import EditIntershipNewsPopup from '@/components/EditIntershipNewsPopup'
import DeleteIntershipNewsPopup from '@/components/DeleteIntershipNewsPopup'
import { adminApi } from "@/api/admin";
import { commonUtils } from "@/utils/commonUtils.js";

export default {
  components: {
    CreateIntershipNewsPopup, EditIntershipNewsPopup, DeleteIntershipNewsPopup
  },
  data() {
    return {
      selectedFile: null,
      selectedItem: {},
      intershipNewsList: [],
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0,
      loading: false,
      headers: [
        { text: '新闻标题', value: 'newsTitle' },
        { text: '工作地点', value: 'workPlace' },
        { text: '招聘类型', value: 'recruitmentType' },
        { text: '招聘渠道', value: 'recruitmentChannel' },
        { text: '最后修改时间', value: 'lastModifiedDateTime' },
        { text: '操作', value: 'actions', sortable: false }
      ],
      itemsPerPageOptions: [10,30,50,100],
    };
  },
  mounted() {
    this.fetchIntershipNews()
  },
  methods: {
    async fetchIntershipNews() {
      this.loading = true
      try {
        const response = await adminApi.getIntershipNews(
          this.currentPage,
          this.itemsPerPage
        )
        
        if (response.code === '2000') {
          this.intershipNewsList = response.data.intershipNewsList;
          this.totalItems = response.data.totalItems;
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('数据加载失败', errorMessage);
      } finally {
        this.loading = false
      }
    },

    handlePageChange(newPage) {
      this.currentPage = newPage
      this.fetchIntershipNews()
    },

    handleItemsPerPageChange(newSize) {
      this.itemsPerPage = newSize
      this.currentPage = 1
      this.fetchIntershipNews()
    },


    handleFileChange(file) {
      // 这里可以添加额外的文件验证逻辑
      this.selectedFile = file;
    },
    async downloadTemplate() {
      try {
        // 调用 adminApi 方法获取文件
        const response =
          await adminApi.downloadIntershipNewsBatchCreateTemplateExcel();
        commonUtils.popupDownloadFile(response);
      } catch (error) {
        console.log(error);
        alert(`错误代码: ${error.code}\n错误信息: ${error.message}`);
      }
    },
    async downloadErrorExcelLog() {
      try {
        const response =
          await adminApi.downloadIntershipNewsBatchCreateErrorLogExcel();
        commonUtils.popupDownloadFile(response);
      } catch (error) {
        alert(
          `错误代码: ${error.code}\n错误信息: ${error.message} 查无上次错误日志 !`
        );
      }
    },
    async importIntershipNewsExcel() {
      if (!this.selectedFile) {
        alert("Please select a file to upload.");
        return;
      }

      try {
        const response = await adminApi.uploadIntershipNewsBatchCreateExcel(
          this.selectedFile
        );
        alert(
          `操作讯息:\n 代码: ${response.code} \n 讯息:${response.message} 汇入成功`
        );
      } catch (error) {
        alert(`错误代码: ${error.code}\n错误信息: ${error.message}`);
      }
    },
    showCreateIntershipNewsDialog() {
      this.$refs.createPopup.open();
    },
    showEditIntershipNewsDialog(item) {
      this.$refs.editPopup.open(item.id); // 假设数据项中有newsId字段
    },
    showDeleteIntershipNewsConfirm(item) {
      this.selectedItem = item;
      this.$refs.deletePopup.open();
    }
  },
};
</script>